var _defs, _g, _g2, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFechaBf25({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    viewBox: "0 0 543.2 195.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "      .st0, .st1 {        fill: #fff;      }      .st1 {        isolation: isolate;      }      .st2 {        fill: #b7182e;      }      .st3 {        font-size: 45px;      }      .st4 {        fill: #c42935;      }      .st5, .st6 {        font-family: RedHatDisplay-ExtraBold, 'Red Hat Display';        font-weight: 700;      }      .st7 {        font-family: RedHatDisplay-SemiBold, 'Red Hat Display';        font-weight: 600;      }      .st6 {        font-size: 38px;      }    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M56.68,137.23c-7.6-1.3-13.5-7.2-14.8-14.8,0-.6-.6-1.1-1.2-1.1s-1.1.4-1.2,1c-1.3,7.6-7.2,13.5-14.8,14.8-.6,0-1.1.6-1.1,1.2s.4,1.1,1,1.2c7.6,1.3,13.5,7.2,14.8,14.8,0,.6.6,1,1.2,1s1.1-.4,1.2-1c1.3-7.6,7.2-13.5,14.8-14.8.6,0,1-.6,1-1.2s-.4-1.1-1-1.2l.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M518.72,137.23c-7.6-1.3-13.5-7.2-14.8-14.8,0-.6-.6-1.1-1.2-1.1s-1.1.4-1.2,1c-1.3,7.6-7.2,13.5-14.8,14.8-.6,0-1.1.6-1.1,1.2s.4,1.1,1,1.2c7.6,1.3,13.5,7.2,14.8,14.8,0,.6.6,1,1.2,1s1.1-.4,1.2-1c1.3-7.6,7.2-13.5,14.8-14.8.6,0,1-.6,1-1.2s-.4-1.1-1-1.2l.1.1Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x31_5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.1,22.3h-48.9c-2,0-3.6,1.6-3.6,3.6v43.4c0,2,1.6,3.6,3.6,3.6h48.9c2,0,3.6-1.6,3.6-3.6V25.9c0-2-1.6-3.6-3.6-3.6ZM296.1,69.3h-48.9v-32.8h48.9v32.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.5,47.5h6.4c.3,0,.5-.2.5-.5v-5.6c0-.3-.2-.5-.5-.5h-6.4c-.3,0-.5.2-.5.5v5.6c0,.3.2.5.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284,47.5h6.4c.3,0,.5-.2.5-.5v-5.6c0-.3-.2-.5-.5-.5h-6.4c-.3,0-.5.2-.5.5v5.6c0,.3.2.5.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.4,56.7h6.4c.3,0,.5-.2.5-.5v-5.6c0-.3-.2-.5-.5-.5h-6.4c-.3,0-.5.2-.5.5v5.6c0,.3.2.5.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.9,56.7h6.4c.3,0,.5-.2.5-.5v-5.6c0-.3-.2-.5-.5-.5h-6.4c-.3,0-.5.2-.5.5v5.6c0,.3.2.5.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.5,56.7h6.4c.3,0,.5-.2.5-.5v-5.6c0-.3-.2-.5-.5-.5h-6.4c-.3,0-.5.2-.5.5v5.6c0,.3.2.5.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284,56.7h6.4c.3,0,.5-.2.5-.5v-5.6c0-.3-.2-.5-.5-.5h-6.4c-.3,0-.5.2-.5.5v5.6c0,.3.2.5.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.9,59.3h-6.4c-.3,0-.5.2-.5.5v5.6c0,.3.2.5.5.5h6.4c.3,0,.5-.2.5-.5v-5.6c0-.3-.2-.5-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M269.4,59.3h-6.4c-.3,0-.5.2-.5.5v5.6c0,.3.2.5.5.5h6.4c.3,0,.5-.2.5-.5v-5.6c0-.3-.2-.5-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M279.9,59.3h-6.4c-.3,0-.5.2-.5.5v5.6c0,.3.2.5.5.5h6.4c.3,0,.5-.2.5-.5v-5.6c0-.3-.2-.5-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.4,59.3h-6.4c-.3,0-.5.2-.5.5v5.6c0,.3.2.5.5.5h6.4c.3,0,.5-.2.5-.5v-5.6c0-.3-.2-.5-.5-.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M296.1,26h-49v7.9h49v-7.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 251.4,
    y: 19.9,
    width: 4.1,
    height: 9.7,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 263.5,
    y: 19.9,
    width: 4.1,
    height: 9.7,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 275.6,
    y: 19.9,
    width: 4.1,
    height: 9.7,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 287.7,
    y: 19.9,
    width: 4.1,
    height: 9.7,
    rx: 1.2,
    ry: 1.2
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(156.58 134.22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st5",
    x: 0,
    y: 0
  }, "28, 29 "), /*#__PURE__*/React.createElement("tspan", {
    className: "st7",
    x: 138.96,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "st5",
    x: 163.17,
    y: 0,
    xmlSpace: "preserve"
  }, " 30")), /*#__PURE__*/React.createElement("tspan", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 17.11,
    y: 47
  }, "noviembre")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFechaBf25);
export default __webpack_public_path__ + "static/media/fecha_bf25.5ba720c5df5fee64e8232a09302837ff.svg";
export { ForwardRef as ReactComponent };